// b2b/components/PageLoader.jsx
export default function PageLoader({ show, label = 'Chargement…' }) {
  if (!show) return null;
    const txtStyle = { marginTop: 12, fontWeight: 600, color: "#334155" };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(255,255,255,0.85)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, backdropFilter: "blur(2px)",
    }}>
      <div className="text-center">
        <div className="spinner-border mb-2" role="status" />
        <div className="fw-semibold" style={txtStyle}>{label}</div>
      </div>
    </div>
  );
}
